import { c as _c } from "react/compiler-runtime";
import { BlogPostDirection } from "@/constants/BlogPostDirection";
import type { AdjacentPosts } from "@/types/contentful/AdjacentPosts";
import { BlogNavLink } from "../Blog/BlogNavLink";
interface Props {
  adjacentPosts: AdjacentPosts;
}
export const BlogArticleNavigation = t0 => {
  const $ = _c(11);
  const {
    adjacentPosts
  } = t0;
  const {
    previous,
    next
  } = adjacentPosts;
  if (!previous && !next) {
    return null;
  }
  let t1;
  if ($[0] !== previous) {
    t1 = previous && <BlogNavLink post={previous} direction={BlogPostDirection.Previous} />;
    $[0] = previous;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex items-start gap-3">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== next) {
    t3 = next && <BlogNavLink post={next} direction={BlogPostDirection.Next} />;
    $[4] = next;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="flex items-start gap-3 justify-end text-right">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <nav className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-6 pb-12 px-6 font-sans bg-muted max-w-3xl mx-auto w-full" aria-label="Article navigation">{t2}{t4}</nav>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};